import React, { useEffect, useState } from 'react';
import { FadeIn, Section, Button } from './Shared';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
export function FAQ() {
  const faqs = [{
    q: 'Can I still have pizza?',
    a: "Yes! Our egg-crust 'Perfect Pizza' satisfies the craving with only 10g of carbs."
  }, {
    q: 'Are the ingredients expensive?',
    a: 'No. We use everyday staples like cabbage, eggs, chicken, and butter.'
  }, {
    q: "Is this okay for someone who isn't a 'good' cook?",
    a: 'Absolutely. Most recipes involve simple pan-frying or one-pot baking.'
  }, {
    q: 'Will this help with menopause bloating?',
    a: 'Yes, by removing high-carb inflammatory triggers and focusing on clean proteins.'
  }, {
    q: 'How many servings do the recipes make?',
    a: 'Most recipes serve 2 to 4, making them perfect for couples or meal prep.'
  }, {
    q: 'Do I need a spiralizer for the noodles?',
    a: "No! We show you how to make 'zoodles' using just a regular kitchen fork."
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <Section className="bg-white" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <FadeIn data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-56">
            Frequently Asked Questions
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, idx) => {
          const isOpen = openIdx === idx;
          return <FadeIn key={idx} delay={idx * 0.1} data-id="element-58">
                <div className="border border-cream-dark rounded-2xl overflow-hidden bg-cream/30" data-id="element-59">
                  <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIdx(isOpen ? null : idx)} data-id="element-60">
                    <span className="font-bold text-lg font-sans text-charcoal pr-4" data-id="element-61">
                      {faq.q}
                    </span>
                    <span className="text-sage flex-shrink-0" data-id="element-62">
                      {isOpen ? <RemoveIcon data-id="element-63" /> : <AddIcon data-id="element-64" />}
                    </span>
                  </button>
                  <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-65">
                    <p className="text-charcoal-light leading-relaxed" data-id="element-66">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </Section>;
}
export function FinalCTA() {
  return <Section className="bg-sage text-white text-center rounded-t-[3rem] mt-12" data-id="element-67">
      <div className="max-w-3xl mx-auto py-12" data-id="element-68">
        <FadeIn data-id="element-69">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-70">
            Reclaim your kitchen and your confidence.
          </h2>
          <p className="text-xl text-sage-light text-white/90 mb-10 leading-relaxed" data-id="element-71">
            The "21-Day Keto Kitchen" is your shortcut to a lighter, more
            energized version of yourself. Download the full 21-recipe blueprint
            for free today.
          </p>
          <Button variant="primary" className="text-xl px-10 py-5 w-full sm:w-auto shadow-xl" data-id="element-72">
            Get the 21 Recipes for Free
          </Button>
          <p className="mt-6 text-sm text-white/70" data-id="element-73">
            Join thousands of women who have simplified their weight loss
            journey.
          </p>
        </FadeIn>
      </div>
    </Section>;
}
function LegalModal({
  open,
  onClose,
  title,
  children
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);
  if (!open) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-74">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-charcoal-dark/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-75" />

      {/* Modal panel */}
      <div className="relative bg-cream w-full max-w-2xl max-h-[85vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden" data-id="element-76">
        <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-cream-dark" data-id="element-77">
          <h2 id="legal-modal-title" className="text-2xl font-serif font-bold text-charcoal-dark" data-id="element-78">
            {title}
          </h2>
          <button onClick={onClose} aria-label="Close" className="text-charcoal-light hover:text-charcoal-dark transition-colors p-1 rounded-full hover:bg-cream-dark" data-id="element-79">
            <CloseIcon data-id="element-80" />
          </button>
        </div>
        <div className="overflow-y-auto px-6 md:px-8 py-6 text-charcoal leading-relaxed text-base space-y-5" data-id="element-81">
          {children}
        </div>
      </div>
    </div>;
}
const PrivacyContent = <>
    <p className="text-sm text-charcoal-light" data-id="element-82">
      Last updated:{' '}
      {new Date().toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    })}
    </p>
    <p data-id="element-83">
      Your privacy matters to us. This Privacy Policy explains how we collect,
      use, and protect the information you provide when you download The 21-Day
      Keto Kitchen guide and use our website.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-84">
      Information We Collect
    </h3>
    <p data-id="element-85">
      When you request the free recipe guide, we collect your email address so
      we can deliver the download and send related nutrition tips. We may also
      collect anonymous analytics data such as pages visited, browser type, and
      approximate location to improve the site experience.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-86">
      How We Use Your Information
    </h3>
    <p data-id="element-87">
      We use the information you provide to deliver the requested content, send
      occasional helpful emails about keto recipes and lifestyle, and improve
      the quality of our offerings. You can unsubscribe at any time by clicking
      the link at the bottom of any email.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-88">
      Sharing & Third Parties
    </h3>
    <p data-id="element-89">
      We do not sell, rent, or trade your personal information. We use trusted
      third-party services (such as email delivery and analytics providers) that
      are bound to keep your information secure and use it only for the purposes
      we specify.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-90">
      Cookies
    </h3>
    <p data-id="element-91">
      Our website uses cookies and similar technologies to remember your
      preferences and understand how visitors interact with our content. You can
      disable cookies through your browser settings, though some features may
      not work as expected.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-92">
      Your Rights
    </h3>
    <p data-id="element-93">
      You have the right to access, correct, or request deletion of the personal
      data we hold about you. You may also opt out of marketing communications
      at any time. Requests are typically processed within 30 days.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-94">
      Updates to This Policy
    </h3>
    <p data-id="element-95">
      We may update this Privacy Policy occasionally. When we do, we will revise
      the "last updated" date at the top of this page. Continued use of the site
      after changes are posted constitutes acceptance of the updated policy.
    </p>
  </>;
const TermsContent = <>
    <p className="text-sm text-charcoal-light" data-id="element-96">
      Last updated:{' '}
      {new Date().toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    })}
    </p>
    <p data-id="element-97">
      By accessing this website and downloading The 21-Day Keto Kitchen guide,
      you agree to the following Terms & Conditions. Please read them carefully.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-98">
      Use of Content
    </h3>
    <p data-id="element-99">
      The recipes, text, images, and materials provided are for personal,
      non-commercial use only. You may not republish, resell, or redistribute
      the guide or any portion of its contents without our prior written
      permission.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-100">
      No Medical Advice
    </h3>
    <p data-id="element-101">
      The content offered on this website and within the recipe guide is for
      informational and educational purposes only. It is not intended as a
      substitute for professional medical advice, diagnosis, or treatment.
      Always consult a qualified healthcare provider before starting any new
      diet, especially if you have a medical condition or take medication.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-102">
      Individual Results
    </h3>
    <p data-id="element-103">
      Results vary from person to person and depend on factors such as starting
      health, consistency, and individual physiology. We make no guarantees
      regarding specific weight loss, health, or wellness outcomes.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-104">
      Intellectual Property
    </h3>
    <p data-id="element-105">
      All branding, text, design, and recipes on this site are the property of
      The 21-Day Keto Kitchen and protected by applicable copyright and
      trademark laws. Unauthorized use is strictly prohibited.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-106">
      Limitation of Liability
    </h3>
    <p data-id="element-107">
      To the fullest extent permitted by law, we are not liable for any direct,
      indirect, incidental, or consequential damages arising from your use of
      the website or the information contained in the recipe guide.
    </p>

    <h3 className="text-xl font-serif font-bold text-charcoal-dark pt-2" data-id="element-108">
      Changes to These Terms
    </h3>
    <p data-id="element-109">
      We may revise these Terms from time to time. The most current version will
      always be available on this page, and continued use of the site after
      changes implies acceptance of the updated Terms.
    </p>
  </>;
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <>
      <footer className="bg-charcoal text-white/60 py-12 px-6 text-center" data-id="element-110">
        <div className="max-w-4xl mx-auto" data-id="element-111">
          <p className="text-sm mb-4" data-id="element-112">
            © {new Date().getFullYear()} 21-Day Keto Kitchen. All rights
            reserved.
          </p>

          <nav className="flex items-center justify-center gap-6 mb-6" aria-label="Legal" data-id="element-113">
            <button onClick={() => setOpenModal('privacy')} className="text-sm text-white/70 hover:text-white underline-offset-4 hover:underline transition-colors" data-id="element-114">
              Privacy Policy
            </button>
            <span className="text-white/30" aria-hidden="true" data-id="element-115">
              •
            </span>
            <button onClick={() => setOpenModal('terms')} className="text-sm text-white/70 hover:text-white underline-offset-4 hover:underline transition-colors" data-id="element-116">
              Terms & Conditions
            </button>
          </nav>

          <p className="text-xs max-w-2xl mx-auto leading-relaxed opacity-70" data-id="element-117">
            Disclaimer: The information provided on this site is for educational
            purposes only and does not substitute for professional medical
            advice. Consult a medical professional or healthcare provider if
            you're seeking medical advice, diagnoses, or treatment.
          </p>
        </div>
      </footer>

      <LegalModal open={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Privacy Policy" data-id="element-118">
        {PrivacyContent}
      </LegalModal>

      <LegalModal open={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Terms & Conditions" data-id="element-119">
        {TermsContent}
      </LegalModal>
    </>;
}